export default __webpack_public_path__ + "static/media/red-x.6bcba0b3.webp";